
const defaultAll = {
	label: '全部',
	value: null
}
export default {
	props: {
		value: {
			type: [String, null]
		},
		isShowAll: {
			type: Boolean,
			default: true
		},
		gap: {
			type: Number,
			default: 16
		}
	},
	data() {
		return {
			allItem: defaultAll
		}
	},
	computed: {
		displayList() {
			const list = new Array(26).fill(0).map((_, index) => {
				const item = String.fromCharCode(65 + index)
				return {
					label: item,
					value: item
				}
			})
			if (this.isShowAll) {
				list.unshift(defaultAll)
			}
			return list
		}
	},
    methods:{
        handleClick(item) {
            this.$emit('update:value', item.value)
            this.$emit('item-click', item.value)
        }
    }
}
